const { objectToUrlParams, getCookie, sendPreflight, setupInfiniteScroll, addSwatchesToProducts, populateSortByOptions, filterProductsByEarlyDrop } = window.ssUtils;
import { initializeToggle } from './utils.js';

window.searchType = 'products';

document.addEventListener('DOMContentLoaded', async function() {

    const SITE_ID = window.ssSiteId;
    const pageLoadId = window.ssPageLoadId;

    const toggle = initializeToggle('searchContentToggle', '.toggle-option', 'data-type', 'products');

    toggle?.onChange(async value => {
        window.searchType = value;
        window.ssSearchParams.page = 1;
        await performSearch(false, value);
    })

    // Get the URL parameters
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const pathname = url.pathname;
    const searchQuery = urlParams.get('q') || ''; // Get 'q' param or empty string if not present

    const userId = getCookie('ssUserId') || '';
    const sessionId = getCookie('ssSessionIdNamespace') || '';

    window.ssSearchParams = {
        siteId: SITE_ID,
        resultsFormat: 'json',
        q: searchQuery,
        resultsPerPage: 24,
        page: 1,
        userId,
        sessionId,
        pageLoadId,
        domain: window.location.href,
        redirectResponse: 'minimal'
    }

    // on collections pages, we need to set the collection handle as a filter
    // and remove the search query param, but the rest is the same
    if (pathname.includes('/collections/')) {
        const pathParts = pathname.split('/');
        const collectionsIndex = pathParts.indexOf('collections');
        if (collectionsIndex !== -1 && collectionsIndex + 1 < pathParts.length) {
            window.ssSearchParams['bgfilter.collection_handle'] = pathParts[collectionsIndex + 1];

            // Check if there's another path part after the collection handle
            if (collectionsIndex + 2 < pathParts.length && pathParts[collectionsIndex + 2]) {
                // Add the tag value as a filter parameter
                const tagValue = pathParts[collectionsIndex + 2];

                // Also add it as a URL parameter for consistency
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('filters', `filter.tags:${tagValue}`);
                window.history.replaceState({}, '', currentUrl);
            }
        }
        delete window.ssSearchParams.q;
    } else {
        // Set page title to "Search"
        document.title = "Search Results";

        // Update breadcrumbs to show "Search Results"
        const breadcrumbs = document.querySelector('.breadcrumbs');
        if (breadcrumbs) {
            const lastLi = breadcrumbs.querySelector('ol li:last-child');
            if (lastLi) {
                const lastLink = lastLi.querySelector('a');
                if (lastLink) {
                    lastLink.textContent = "Search Results";
                }
            }
        }
    }

    const searchTerm = document.getElementById('search-term');
    if (searchTerm && window.ssSearchParams.q) {
        searchTerm.textContent = `Search results for: "${window.ssSearchParams.q}"`;
    }



    // Set initial filter checkboxes based on URL
    setInitialFilters();

    // Initial search when page loads
    await performSearch(false, window.searchType);

    // Function to perform the search query
    async function performSearch(isLoadMore = false, type = 'products') {
        const productCards = new ProductCards('product-grid');

        // Only show loading skeletons for the first page
        if (window.ssSearchParams.page === 1) {
            productCards.renderSkeletons(24);
        }

        // Get the URL parameters and update search query
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('q') || '';
        if (searchQuery) {
            window.ssSearchParams.q = searchQuery;
        }

        // Apply filters from URL to search params (if not coming from updateFilters)
        if (!isLoadMore) {
            applyFiltersFromUrl();
        }

        applySortFromUrl();

        const SITE_ID = type === 'products' ? window.ssSiteId : 'm6y9h3';

        const queryString = objectToUrlParams({
            ...window.ssSearchParams,
            siteId: SITE_ID
        });

        // Build the SearchSpring API URL with the query parameter
        const apiUrl = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?bgfilter.status=active&${queryString}`;

        try {
            // Send preflight request first
            await sendPreflight();

            // Make the GET request to the SearchSpring API
            const response = await fetch(apiUrl);

            // Handle redirects
            if (response.redirected) {
                window.location.href = response.url;
                return;
            }

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // Handle redirect from the response data
            if (data?.merchandising?.redirect) {
                window.location.href = data.merchandising.redirect;
                return;
            }

            const filteredResults = await filterProductsByEarlyDrop(data.results);

            // Process products with swatches
            const productsWithSwatches = await addSwatchesToProducts(filteredResults);

            // Add inline merchandising to results
            if (data.merchandising?.content?.inline?.length > 0) {
                data.merchandising.content.inline.forEach(item => {
                    const content = item.value;
                    const {index} = item.config?.position || 0;
                    // only show the inline banner if its index falls within the current page
                    if (index >= (window.ssSearchParams.page * window.ssSearchParams.resultsPerPage - window.ssSearchParams.resultsPerPage) && index < (window.ssSearchParams.page * window.ssSearchParams.resultsPerPage)) {
                        productsWithSwatches.splice(index, 0, {
                            content,
                            isMerchandising: true,
                        });
                    }
                });
            }

            // Render the products
            productCards.render(productsWithSwatches, !isLoadMore);

            // Set up infinite scrolling after the first batch of products is rendered
            if (!isLoadMore) {
                // Small delay to ensure DOM is updated before setting up the sentinel
                setTimeout(() => {
                    setupInfiniteScroll('ss-search-results', window.isLoadingMore, () => {
                        window.isLoadingMore = true;
                        window.ssSearchParams.page += 1;
                        performSearch(true, window.searchType);
                    });
                }, 500);
            }

            // Handle merchandising content
            if (Object.keys(data?.merchandising?.content || {}).length > 0) {
                processSearchMerchandisingContent(data.merchandising.content);
            }

            // Update sort options if available
            if (data?.sorting?.options?.length > 0) {
                populateSortByOptions(data.sorting.options);
            }

            // Update result count
            updateResultCount(data.pagination?.totalResults || 0);

            // Check if we've loaded all results
            if (data.pagination &&
                data.pagination.totalResults <= data.pagination.begin + data.results.length) {
                removeScrollSentinel();
            }

            // Process facets
            processFacets(data.facets);

            // Reset loading flag
            window.isLoadingMore = false;

            // Update filter chips UI
            updateFilterChips();

        } catch (error) {
            // Don't log errors for intentional redirects
            if (!error.message.startsWith('Redirecting to')) {
                console.error('Error fetching search results:', error);
            }
            window.isLoadingMore = false;
        }
    }

    // Helper function to process merchandising content
    function processSearchMerchandisingContent(merchandisingContent) {
        Object.keys(merchandisingContent).forEach(key => {
            const targetElement = document.getElementById(`ss-merchandising-${key}`);

            if (!targetElement || !Array.isArray(merchandisingContent[key])) return;

            // Clear any existing content
            targetElement.innerHTML = '';

            // Process each HTML element for this key
            merchandisingContent[key].forEach(htmlContent => {
                // Check if content is wrapped in script tags and remove them
                const scriptRegex = /^<script[^>]*>([\s\S]*)<\/script>$/i;
                const match = scriptRegex.exec(htmlContent);
                const cleanContent = match && match[1] ? match[1].trim() : htmlContent;

                // Append the cleaned content
                targetElement.innerHTML += cleanContent;
            });
        });
    }

    // Helper function to update result count
    function updateResultCount(totalResults) {
        const resultCount = document.getElementById('ss-search-results-count');
        if (resultCount) {
            resultCount.textContent = `Found ${totalResults} results`;
        }
    }

    // Helper function to remove scroll sentinel
    function removeScrollSentinel() {
        const sentinel = document.getElementById('scroll-sentinel');
        if (sentinel) {
            if (sentinel._observer) {
                sentinel._observer.disconnect();
            }
            sentinel.remove();
        }
    }

    // Helper function to process facets
    function processFacets(facets) {
        if (!facets) return;

        const productTypeFacet = facets.find(facet => facet.field === 'product_type');
        if (productTypeFacet) {
            productTypeFacet.values = productTypeFacet.values.filter(
                value => value.value.toLowerCase() !== 'hidden'
            );
            renderFilterFields(productTypeFacet);
        }

        const priceFacet = facets.find(facet => facet.field === 'ss_price');
        if (priceFacet) {
            renderFilterFields(priceFacet);
        }

        const sizeFacet = facets.find(facet => facet.field === 'ss_sizes');
        if (sizeFacet) {
            // Sort size values in specific order: YS, YM, YL, YXL, S, M, L, XL, 2XL, 3XL
            if (sizeFacet.values && sizeFacet.values.length > 0) {
                const sizeOrder = {
                    'YS': 0,
                    'YM': 1,
                    'YL': 2,
                    'YXL': 3,
                    'S': 4,
                    'M': 5,
                    'L': 6,
                    'XL': 7,
                    '2XL': 8,
                    '3XL': 9
                };

                sizeFacet.values.sort((a, b) => {
                    const labelA = a.label || '';
                    const labelB = b.label || '';

                    // If both labels are in our order map, sort by the order
                    if (labelA in sizeOrder && labelB in sizeOrder) {
                        return sizeOrder[labelA] - sizeOrder[labelB];
                    }
                    // If only one is in the order map, prioritize it
                    else if (labelA in sizeOrder) {
                        return -1;
                    }
                    else if (labelB in sizeOrder) {
                        return 1;
                    }
                    // Otherwise, use alphabetical sorting
                    return labelA.localeCompare(labelB);
                });
            }
            renderFilterFields(sizeFacet);
        }

        updateFilterCounts(facets);
    }

    function applySortFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);

        // Clear all existing sort parameters before applying new ones
        Object.keys(window.ssSearchParams).forEach(key => {
            if (key.startsWith('sort.')) {
                delete window.ssSearchParams[key];
            }
        });

        // Check all URL parameters for any that start with "sort."
        for (const [key, value] of urlParams.entries()) {
            if (key.startsWith('sort.')) {
                window.ssSearchParams[key] = value;
                break;
            }
        }
    }

    // Helper function to apply filters from URL to search params
    function applyFiltersFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = urlParams.get('filters') || '';

        // Clear all existing filter parameters before applying new ones
        Object.keys(window.ssSearchParams).forEach(key => {
            if (key.startsWith('filter.')) {
                delete window.ssSearchParams[key];
            }
        });

        if (filters) {
            const filtersArray = filters.split(',');
            filtersArray.forEach(filter => {
                const [key, value] = filter.split(':');

                // Check if this is a range filter (ends with .low or .high)
                const isRangeFilter = key.endsWith('.low') || key.endsWith('.high');

                if (isRangeFilter) {
                    // For range filters, we just add them directly to the params
                    if (window.ssSearchParams[key] !== undefined) {
                        if (Array.isArray(window.ssSearchParams[key])) {
                            window.ssSearchParams[key].push(value);
                        } else {
                            window.ssSearchParams[key] = [window.ssSearchParams[key], value];
                        }
                    } else {
                        window.ssSearchParams[key] = value;
                    }
                } else {
                    // Regular filters with possible multiple values
                    value.split('|').forEach(v => {
                        if (window.ssSearchParams[key] !== undefined) {
                            if (Array.isArray(window.ssSearchParams[key])) {
                                window.ssSearchParams[key].push(v);
                            } else {
                                window.ssSearchParams[key] = [window.ssSearchParams[key], v];
                            }
                        } else {
                            window.ssSearchParams[key] = v;
                        }
                    });
                }
            });
        }
    }

    function updateFilters(filterName, selectedValues, isRangeFilter = false) {

        const url = new URL(window.location.href);
        const searchParams = url.searchParams;

        let filtersParam = searchParams.get('filters') || '';
        let filterArray = filtersParam ? filtersParam.split(',') : [];

        if (isRangeFilter) {
            // Handle range filters differently
            // Remove any existing range filters for this filter name
            filterArray = filterArray.filter(filter =>
                !filter.startsWith(`filter.${filterName}.low:`) &&
                !filter.startsWith(`filter.${filterName}.high:`)
            );

            // Add new range filters if values are selected
            if (selectedValues.length > 0) {
                // For range filters, we expect selectedValues to be an array of objects with low and high properties
                selectedValues.forEach(range => {
                    if (range.low !== undefined) {
                        filterArray.push(`filter.${filterName}.low:${range.low}`);
                    }
                    if (range.high !== undefined) {
                        filterArray.push(`filter.${filterName}.high:${range.high}`);
                    }
                });
            }
        } else {
            // Original code for regular filters
            filterArray = filterArray.filter(filter => !filter.startsWith(`filter.${filterName}:`));

            if (selectedValues.length > 0) {
                const valueString = selectedValues.join('|');
                filterArray.push(`filter.${filterName}:${valueString}`);
            }
        }

        // Update the URL search parameter
        if (filterArray.length > 0) {
            searchParams.set('filters', filterArray.join(','));
        } else {
            searchParams.delete('filters');
        }

        window.history.replaceState({}, '', url.toString());

        updateFilterChips();

        // Reset to page 1 when filters change
        window.ssSearchParams.page = 1;

        // Now perform the search with updated parameters
        performSearch(false, window.searchType);
    }

    // Select all fieldsets
    const fieldsets = document.querySelectorAll('.search-filters-panel-body fieldset');

    // Add event listeners to each fieldset
    fieldsets.forEach(fieldset => {
        fieldset.addEventListener('click', function(event) {
            // Check if the clicked element is a checkbox
            if (event.target.type === 'checkbox') {
                // Get the filter name from the data attribute
                const filterName = this.getAttribute('data-filter-name');
                // Check if this is a range filter
                const isRangeFilter = this.hasAttribute('data-range-filter');

                if (isRangeFilter) {
                    // For range filters, collect objects with low/high values
                    const checkedBoxes = this.querySelectorAll(`input[name="${filterName}"]:checked`);
                    const selectedRanges = Array.from(checkedBoxes).map(checkbox => {
                        // Get the range data from the checkbox
                        return {
                            low: checkbox.getAttribute('data-low'),
                            high: checkbox.getAttribute('data-high')
                        };
                    });

                    updateFilters(filterName, selectedRanges, true);
                } else {
                    // Regular filter handling
                    const checkedBoxes = this.querySelectorAll(`input[name="${filterName}"]:checked`);
                    const selectedValues = Array.from(checkedBoxes).map(checkbox => checkbox.value);

                    updateFilters(filterName, selectedValues, false);
                }
            }
        });
    });

    function updateFilterCounts(facets) {
        const counts = document.querySelectorAll('.search-filters-panel-body .count');
        counts.forEach(count => {
            count.textContent = '';
        });

        facets.forEach(facet => {
            const facetFieldset = document.querySelector(`[data-filter-name="${facet.field}"]`);
            if (facetFieldset) {
                // Check if this is a range fieldset
                const isRangeFieldset = facetFieldset.hasAttribute('data-range-filter');

                facet.values.forEach((value, index) => {
                    // Different handling based on value type
                    const isRangeValue = value.type === 'range';

                    if (isRangeValue || isRangeFieldset) {
                        // For range values/fieldsets, use the index-based ID
                        const rangeId = `${facet.field}-range-${index}`;
                        const label = facetFieldset.querySelector(`label[for="${rangeId}"]`);

                        if (label) {
                            const countEl = label.querySelector('.count');
                            if (countEl) {
                                countEl.textContent = `(${value.count || 0})`;
                            }
                        }
                    } else {
                        // For regular values, use value as ID
                        // Make sure value.value exists
                        if (!value.value) return;

                        // Remove double quotes if they exist around the value
                        const cleanValue = value.value.replace(/^"(.*)"$/, '$1');
                        const label = facetFieldset.querySelector(`label[for="${cleanValue}"]`);

                        if (label) {
                            const countEl = label.querySelector('.count');
                            if (countEl) {
                                countEl.textContent = `(${value.count || 0})`;
                            }
                        }
                    }
                });
            }
        });
    }

    function setInitialFilters() {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = urlParams.get('filters') || '';

        if (!filters) return; // No filters to apply

        // Parse the filters string into a more usable structure
        const filterMap = {};
        const rangeFilterMap = {};
        const filtersArray = filters.split(',');

        filtersArray.forEach(filter => {
            // Make sure the filter has both key and value parts
            const parts = filter.split(':');
            if (parts.length !== 2) return; // Skip malformed filters

            const [key, value] = parts;

            // Skip if key is undefined or empty
            if (!key) return;

            // Check if this is a range filter
            if (key.includes('.low') || key.includes('.high')) {
                // Extract the base filter name and range type
                // Make sure to handle potential undefined values
                const keyParts = key.replace('filter.', '').split('.');
                if (keyParts.length !== 2) return; // Skip malformed range filters

                const filterName = keyParts[0];
                const rangeType = keyParts[1]; // 'low' or 'high'

                // Skip if filterName or rangeType is empty
                if (!filterName || !rangeType) return;

                // Initialize the range filter map entry if needed
                if (!rangeFilterMap[filterName]) {
                    rangeFilterMap[filterName] = [];
                }

                // Store the range value in an array
                // Find an existing range with this type or add a new one
                let found = false;
                for (const range of rangeFilterMap[filterName]) {
                    if (!range[rangeType]) {
                        range[rangeType] = value;
                        found = true;
                        break;
                    }
                }

                // If we didn't find a place to add this value, create a new range object
                if (!found) {
                    const newRange = {};
                    newRange[rangeType] = value;
                    rangeFilterMap[filterName].push(newRange);
                }
            } else {
                // Regular filter
                const filterName = key.replace('filter.', '');
                if (!filterName) return; // Skip if filterName is empty

                const values = value.split('|');
                filterMap[filterName] = values;
            }
        });

        // Find all filter fieldsets
        const fieldsets = document.querySelectorAll('.search-filters-panel-body fieldset');

        fieldsets.forEach(fieldset => {
            const filterName = fieldset.getAttribute('data-filter-name');
            if (!filterName) return; // Skip if no filter name

            const isRangeFilter = fieldset.hasAttribute('data-range-filter');

            if (isRangeFilter && rangeFilterMap[filterName]) {
                // Range filter handling
                const rangeData = rangeFilterMap[filterName];

                // Find all range checkboxes
                const checkboxes = fieldset.querySelectorAll(`input[name="${filterName}"]`);

                checkboxes.forEach(checkbox => {
                    const checkboxLow = checkbox.getAttribute('data-low');
                    const checkboxHigh = checkbox.getAttribute('data-high');

                    // Check if any of our range filters match this checkbox
                    const isChecked = rangeData.some(range => {
                        // Check various matching conditions
                        return (
                            // Both low and high match
                            (range.low === checkboxLow && range.high === checkboxHigh) ||
                            // Only low matches (and checkbox has low)
                            (range.low === checkboxLow && !range.high && checkboxLow) ||
                            // Only high matches (and checkbox has high)
                            (range.high === checkboxHigh && !range.low && checkboxHigh) ||
                            // Only checkbox has low, and it matches range low
                            (checkboxLow && !checkboxHigh && range.low === checkboxLow) ||
                            // Only checkbox has high, and it matches range high
                            (checkboxHigh && !checkboxLow && range.high === checkboxHigh)
                        );
                    });

                    if (isChecked) {
                        checkbox.checked = true;
                    }
                });
            } else if (filterMap[filterName]) {
                // Regular filter handling
                const filterValues = filterMap[filterName];
                const checkboxes = fieldset.querySelectorAll(`input[name="${filterName}"]`);

                checkboxes.forEach(checkbox => {
                    if (filterValues.includes(checkbox.value)) {
                        checkbox.checked = true;
                    }
                });
            }
        });
    }

    function renderFilterFields(facet) {
        const fieldset = document.querySelector(`[data-filter-name="${facet.field}"]`);
        if (!fieldset) return;

        fieldset.innerHTML = '';

        // We'll determine if this is a range fieldset by checking the first value
        let isRangeFieldset = false;
        if (facet.values && facet.values.length > 0 && facet.values[0].type === 'range') {
            isRangeFieldset = true;
            fieldset.setAttribute('data-range-filter', 'true');
        }

        const valuesToRender = facet.values || [];

        valuesToRender.forEach((value, index) => {
            const container = document.createElement('div');
            container.classList.add('flex-1', 'flex', 'align-center');

            if (facet.field === 'ss_sizes') {
                if (index < valuesToRender.length / 2) {
                    container.classList.add('column-1');
                } else {
                    container.classList.add('column-2');
                }
            }

            const input = document.createElement('input');
            input.type = 'checkbox';
            input.name = facet.field;

            // Individual value can be range type
            const isRangeValue = value.type === 'range';

            // Set ID appropriately based on value type
            if (isRangeValue) {
                input.id = `${facet.field}-range-${index}`;
            } else {
                input.id = value.value;
            }

            // For range values, add data attributes
            if (isRangeValue) {
                // For range values, check for low/high properties
                if ('low' in value) input.setAttribute('data-low', value.low);
                if ('high' in value) input.setAttribute('data-high', value.high);
                // Used for facet identification
                input.value = `range-${index}`;
            } else {
                input.value = value.value;
            }

            const label = document.createElement('label');
            label.classList.add('flex', 'align-center');
            label.htmlFor = input.id;
            label.textContent = value.label || value.value;

            const count = document.createElement('small');
            count.classList.add('count');
            count.textContent = value.count !== undefined ? `(${value.count})` : '';

            container.appendChild(input);
            container.appendChild(label);
            label.appendChild(count);

            fieldset.appendChild(container);
        });

        setInitialFilters();
    }

    function clearFilters() {
        // Check if there is a filters search param in the URL
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;

        // Uncheck all filter checkboxes
        const filterCheckboxes = document.querySelectorAll('.search-filters-panel-body input[type="checkbox"]');
        filterCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });

        if (!searchParams.has('filters')) {
            return; // No filters to clear, so return early
        }

        window.ssSearchParams.page = 1;
        searchParams.delete('filters');
        window.history.replaceState({}, '', url.toString());

        performSearch(false, window.searchType);
    }

    // Add event listener to the clear filters button
    const clearFiltersButton = document.querySelector('.clear-filters-button');
    if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', clearFilters);
    }

    /**
     * Updates the filter chips display based on active filters
     */
    function updateFilterChips() {
        const container = document.getElementById('ss-search-filter-chips');
        if (!container) return;

        // Clear existing chips
        container.innerHTML = '';

        // Get current filters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const filters = urlParams.get('filters') || '';
        if (!filters) return; // No filters to display

        // Split into individual filters
        const filterArray = filters.split(',');

        // Group filters by name for regular filters
        const regularFilters = {};

        // Group range filters into complete pairs only
        const rangePairs = [];
        const tempRanges = {};

        filterArray.forEach(filter => {
            const parts = filter.split(':');
            if (parts.length !== 2) return;

            const key = parts[0];
            const value = parts[1];

            // Check if it's a range filter
            if (key.includes('.low') || key.includes('.high')) {
                const baseName = key.replace('filter.', '').split('.')[0];
                const rangeType = key.includes('.low') ? 'low' : 'high';

                if (!tempRanges[baseName]) {
                    tempRanges[baseName] = [];
                }

                // Try to find a matching pair
                let matchFound = false;

                for (const rangeObj of tempRanges[baseName]) {
                    // If this object doesn't have this property yet
                    if (!rangeObj[rangeType] && !rangeObj.complete) {
                        // Add this range value
                        rangeObj[rangeType] = value;
                        rangeObj.filters.push(filter);
                        matchFound = true;

                        // If we now have both values, it's a complete pair
                        if (rangeObj.low && rangeObj.high) {
                            rangePairs.push({
                                name: baseName,
                                low: rangeObj.low,
                                high: rangeObj.high,
                                filters: [...rangeObj.filters]
                            });
                            rangeObj.complete = true;
                        }
                        break;
                    }
                }

                // If no match found, create a new range object
                if (!matchFound) {
                    tempRanges[baseName].push({
                        [rangeType]: value,
                        filters: [filter],
                        complete: false
                    });
                }
            } else {
                // Regular filter
                const baseName = key.replace('filter.', '');

                if (!regularFilters[baseName]) {
                    regularFilters[baseName] = { values: [], filters: [] };
                }

                // Add pipe-separated values
                value.split('|').forEach(v => {
                    regularFilters[baseName].values.push(v);
                });

                regularFilters[baseName].filters.push(filter);
            }
        });

        // Create chips for regular filters
        for (const name in regularFilters) {
            const data = regularFilters[name];

            const chip = document.createElement('div');
            chip.className = 'filter-chip';

            // Format values based on filter type
            let displayValues = data.values;

            // Format price values with dollar signs if needed
            if (name === 'ss_price') {
                displayValues = displayValues.map(val => `$${val}`);
            }

            chip.innerHTML = `
                <span>${displayValues.join(', ')}</span>
                <button aria-label="Remove filter" class="filter-chip-remove">&times;</button>
            `;

            // Add click handler to remove all filters for this name
            chip.querySelector('.filter-chip-remove').addEventListener('click', () => {
                removeFiltersFromUrl(data.filters);
            });

            container.appendChild(chip);
        }

        // Create a separate chip for each complete range pair
        rangePairs.forEach(range => {
            const chip = document.createElement('div');
            chip.className = 'filter-chip';

            // Only show ranges with both low and high values
            if (!range.low || !range.high) return;

            // Format range text
            let rangeText = '';
            const isPriceFilter = range.name === 'ss_price';

            if (isPriceFilter) {
                rangeText = `$${range.low} - $${range.high}`;
            } else {
                rangeText = `${range.low} - ${range.high}`;
            }

            chip.innerHTML = `
                <span>${rangeText}</span>
                <button aria-label="Remove filter" class="filter-chip-remove">&times;</button>
            `;

            // Add click handler to remove this specific range
            chip.querySelector('.filter-chip-remove').addEventListener('click', () => {
                removeFiltersFromUrl(range.filters);
            });

            container.appendChild(chip);
        });
    }

    /**
     * Removes specified filters from URL and updates search
     */
    function removeFiltersFromUrl(filtersToRemove) {
        const url = new URL(window.location.href);
        const filtersParam = url.searchParams.get('filters') || '';

        if (!filtersParam) return;

        // Get all filters and filter out the ones to remove
        let filterArray = filtersParam.split(',');
        filterArray = filterArray.filter(filter => !filtersToRemove.includes(filter));

        // Update URL
        if (filterArray.length > 0) {
            url.searchParams.set('filters', filterArray.join(','));
        } else {
            url.searchParams.delete('filters');
        }

        // Update browser history
        window.history.replaceState({}, '', url.toString());

        // Reset to page 1
        window.ssSearchParams.page = 1;

        // Update search params and perform search
        applyFiltersFromUrl();
        performSearch(false, window.searchType);
    }

    // Add event listener to update url params and perform search when sort by select changes
    const sortBySelect = document.getElementById('SortBy');
    if (sortBySelect) {
        sortBySelect.addEventListener('change', function() {
            const selectedValue = this.value;
            // Update URL with the selected sort option
            const url = new URL(window.location.href);

            // Remove any existing sort parameters
            for (const [key, value] of [...url.searchParams.entries()]) {
                if (key.startsWith('sort.')) {
                    url.searchParams.delete(key);
                }
            }

            // Add the new sort parameter
            if (selectedValue) {
                const [key, value] = selectedValue.split('=');
                url.searchParams.set(key, value);
            }

            // Update browser history
            window.history.replaceState({}, '', url.toString());

            // reset page to 1
            window.ssSearchParams.page = 1;
            performSearch(false, window.searchType);
        });
    }
});
